export default "__VITE_ASSET__sfX1GoZ___"